export const ClockModalIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      fill="#ED6C02"
      fillOpacity="0.4"
    />
    <rect
      x="4"
      y="4"
      width="48"
      height="48"
      rx="24"
      stroke="#FFEFE1"
      strokeWidth="8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.25 28C18.25 22.617 22.617 18.25 28 18.25C33.383 18.25 37.75 22.617 37.75 28C37.75 33.383 33.383 37.75 28 37.75C22.617 37.75 18.25 33.383 18.25 28ZM28 19.75C23.4455 19.75 19.75 23.4455 19.75 28C19.75 32.5545 23.4455 36.25 28 36.25C32.5545 36.25 36.25 32.5545 36.25 28C36.25 23.4455 32.5545 19.75 28 19.75Z"
      fill="#ED6C02"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 21.25C28.4142 21.25 28.75 21.5858 28.75 22V28H32.5C32.9142 28 33.25 28.3358 33.25 28.75C33.25 29.1642 32.9142 29.5 32.5 29.5H28C27.5858 29.5 27.25 29.1642 27.25 28.75V22C27.25 21.5858 27.5858 21.25 28 21.25Z"
      fill="#ED6C02"
    />
  </svg>
);
